document.addEventListener("DOMContentLoaded", () => {

    const builder = document.querySelector("#bundle-builder");

    if (!builder) return;

    const required = parseInt(builder.dataset.qty);

    const bundlePrice = builder.dataset.price;

    const progressFill = document.querySelector("#bundle-progress-fill");
    const progressText = document.querySelector("#bundle-selected-count");

    const footerCount = document.querySelector("#bundle-count");
    const footerMessage = document.querySelector("#bundle-message");

    const checkoutBtn = document.querySelector("#bundle-checkout");

    const strip = document.querySelector("#bundle-strip-items");

    let selectedProducts = [];

    function updateUI(){

        const total = selectedProducts.length;

        progressText.innerText = total;

        footerCount.innerText = total;

        progressFill.style.width = ((total / required) * 100) + "%";

        if(total >= required){

            footerMessage.innerHTML = "Your Box is Ready 🎉";

            checkoutBtn.disabled = false;

        }else{

            footerMessage.innerHTML =
                `Select ${required-total} More Product${required-total==1?"":"s"}`;

            checkoutBtn.disabled = true;

        }

        renderStrip();

    }

    function renderStrip(){

        strip.innerHTML="";

        selectedProducts.forEach(item=>{

            strip.insertAdjacentHTML("beforeend",`

                <div class="bundle-strip-item">

                    <img src="${item.image}" alt="">

                    <button
                        class="bundle-remove"
                        data-id="${item.variant}">
                        ×
                    </button>

                </div>

            `);

        });

    }

    document.addEventListener("click",(e)=>{

        if(e.target.classList.contains("bundle-add-btn")){

            const card=e.target.closest(".bundle-card");

            const variant=e.target.dataset.variant;

            if(selectedProducts.find(x=>x.variant==variant)){

                return;

            }

            selectedProducts.push({

                id:e.target.dataset.product,

                variant:variant,

                image:card.querySelector("img").src

            });

            e.target.innerHTML="Added ✓";

            e.target.disabled=true;

            updateUI();

        }

    });

    document.addEventListener("click",(e)=>{

        if(!e.target.classList.contains("bundle-remove")) return;

        const id=e.target.dataset.id;

        selectedProducts=selectedProducts.filter(x=>x.variant!=id);

        document.querySelectorAll(".bundle-add-btn").forEach(btn=>{

            if(btn.dataset.variant==id){

                btn.disabled=false;

                btn.innerHTML="Add To Box";

            }

        });

        updateUI();

    });

    checkoutBtn.addEventListener("click",async()=>{

        if(selectedProducts.length!=required){

            return;

        }

        try{

            await fetch("/cart/clear.js",{

                method:"POST"

            });

            for(const item of selectedProducts){

                await fetch("/cart/add.js",{

                    method:"POST",

                    headers:{
                        "Content-Type":"application/json"
                    },

                    body:JSON.stringify({

                        id:item.variant,

                        quantity:1

                    })

                });

            }

            window.location="/cart";

        }

        catch(err){

            console.error(err);

        }

    });

    updateUI();

});